/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of InvoiceClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfGetInvoicesResponse,
  SuccessResponse_1OfInvoice,
  SuccessResponse_1OfRAG,
  SuccessResponse_1OfIEnumerable_1OfInvoiceRag,
  CreateInvoiceRequest,
  UpdateInvoiceRequest,
  CreateInvoiceItemRequest,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockInvoices = [
  {
    id: 1,
    invoiceNumber: 'INV-2026-001',
    orderNumber: 'GR-2026-001',
    storeNumber: '001',
    billingName: 'Fresh Foods Ltd',
    invoiceDate: '2026-01-03',
    invoiceValue: 1234.56,
    invoiceTotal: 1234.56,
    status: 'Pending',
    invoiceItems: [
      {
        id: 101,
        invoiceId: 1,
        lineNumber: 1,
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        quantity: 10,
        pricePerUnit: 24.50,
        goodsValue: 245.00,
        lineValue: 245.00,
        uom: 'CASE',
        status: 'Pending',
      },
      {
        id: 102,
        invoiceId: 1,
        lineNumber: 2,
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        quantity: 15,
        pricePerUnit: 18.00,
        goodsValue: 270.00,
        lineValue: 270.00,
        uom: 'CASE',
        status: 'Pending',
      },
      {
        id: 103,
        invoiceId: 1,
        lineNumber: 3,
        itemNumber: 'SKU-COFFEE-001',
        itemDescription: 'Premium Coffee Beans 1kg',
        quantity: 5,
        pricePerUnit: 85.00,
        goodsValue: 425.00,
        lineValue: 425.00,
        uom: 'CASE',
        status: 'Pending',
      },
    ],
  },
  {
    id: 2,
    invoiceNumber: 'INV-2026-002',
    orderNumber: 'GR-2026-005',
    storeNumber: '001',
    billingName: 'Fresh Foods Ltd',
    invoiceDate: '2026-01-02',
    invoiceValue: 567.89,
    invoiceTotal: 567.89,
    status: 'Processed',
    invoiceItems: [
      {
        id: 201,
        invoiceId: 2,
        lineNumber: 1,
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        quantity: 18,
        pricePerUnit: 18.00,
        goodsValue: 324.00,
        lineValue: 324.00,
        uom: 'CASE',
        status: 'Approved',
      },
      {
        id: 202,
        invoiceId: 2,
        lineNumber: 2,
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        quantity: 15,
        pricePerUnit: 16.26,
        goodsValue: 243.89,
        lineValue: 243.89,
        uom: 'CASE',
        status: 'Approved',
      },
    ],
  },
  {
    id: 3,
    invoiceNumber: 'INV-2026-003',
    orderNumber: 'GR-2026-006',
    storeNumber: '002',
    billingName: 'Premium Beverages Ltd',
    invoiceDate: '2026-01-04',
    invoiceValue: 935.00,
    invoiceTotal: 935.00,
    status: 'Pending',
    invoiceItems: [
      {
        id: 301,
        invoiceId: 3,
        lineNumber: 1,
        itemNumber: 'SKU-WINE-001',
        itemDescription: 'Red Wine Merlot 750ml',
        quantity: 6,
        pricePerUnit: 125.00,
        goodsValue: 750.00,
        lineValue: 750.00,
        uom: 'CASE',
        status: 'Pending',
      },
      {
        id: 302,
        invoiceId: 3,
        lineNumber: 2,
        itemNumber: 'SKU-BEER-001',
        itemDescription: 'Lager Beer 330ml 24pk',
        quantity: 10,
        pricePerUnit: 18.50,
        goodsValue: 185.00,
        lineValue: 185.00,
        uom: 'CASE',
        status: 'Pending',
      },
    ],
  },
  {
    id: 4,
    invoiceNumber: 'INV-2026-004',
    orderNumber: 'GR-2026-009',
    storeNumber: '004',
    billingName: 'Fresh Foods Ltd',
    invoiceDate: '2026-01-03',
    invoiceValue: 1543.00,
    invoiceTotal: 1543.00,
    status: 'Approved',
    invoiceItems: [
      {
        id: 401,
        invoiceId: 4,
        lineNumber: 1,
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        quantity: 14,
        pricePerUnit: 24.50,
        goodsValue: 343.00,
        lineValue: 343.00,
        uom: 'CASE',
        status: 'Approved',
      },
      {
        id: 402,
        invoiceId: 4,
        lineNumber: 2,
        itemNumber: 'SKU-COFFEE-001',
        itemDescription: 'Premium Coffee Beans 1kg',
        quantity: 8,
        pricePerUnit: 85.00,
        goodsValue: 680.00,
        lineValue: 680.00,
        uom: 'CASE',
        status: 'Approved',
      },
      {
        id: 403,
        invoiceId: 4,
        lineNumber: 3,
        itemNumber: 'SKU-YOGURT-001',
        itemDescription: 'Greek Yogurt 500g',
        quantity: 18,
        pricePerUnit: 28.89,
        goodsValue: 520.00,
        lineValue: 520.00,
        uom: 'CASE',
        status: 'Approved',
      },
    ],
  },
  {
    id: 5,
    invoiceNumber: 'INV-2026-005',
    orderNumber: 'GR-2026-012',
    storeNumber: '005',
    billingName: 'Fresh Foods Ltd',
    invoiceDate: '2026-01-04',
    invoiceValue: 461.00,
    invoiceTotal: 461.00,
    status: 'Processed',
    invoiceItems: [
      {
        id: 501,
        invoiceId: 5,
        lineNumber: 1,
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        quantity: 12,
        pricePerUnit: 18.00,
        goodsValue: 216.00,
        lineValue: 216.00,
        uom: 'CASE',
        status: 'Approved',
      },
      {
        id: 502,
        invoiceId: 5,
        lineNumber: 2,
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        quantity: 10,
        pricePerUnit: 24.50,
        goodsValue: 245.00,
        lineValue: 245.00,
        uom: 'CASE',
        status: 'Approved',
      },
    ],
  },
  {
    id: 6,
    invoiceNumber: 'INV-2026-006',
    orderNumber: 'GR-2026-002',
    storeNumber: '001',
    billingName: 'Ambient Supplies Co',
    invoiceDate: '2026-01-05',
    invoiceValue: 437.20,
    invoiceTotal: 437.20,
    status: 'Pending',
    invoiceItems: [
      {
        id: 601,
        invoiceId: 6,
        lineNumber: 1,
        itemNumber: 'SKU-SUGAR-001',
        itemDescription: 'Granulated Sugar 1kg',
        quantity: 20,
        pricePerUnit: 12.50,
        goodsValue: 250.00,
        lineValue: 250.00,
        uom: 'CASE',
        status: 'Pending',
      },
      {
        id: 602,
        invoiceId: 6,
        lineNumber: 2,
        itemNumber: 'SKU-PASTA-001',
        itemDescription: 'Penne Pasta 500g',
        quantity: 12,
        pricePerUnit: 15.60,
        goodsValue: 187.20,
        lineValue: 187.20,
        uom: 'CASE',
        status: 'Pending',
      },
    ],
  },
  {
    id: 7,
    invoiceNumber: 'INV-2026-007',
    orderNumber: 'GR-2025-999',
    storeNumber: '003',
    billingName: 'Fresh Foods Ltd',
    invoiceDate: '2025-12-30',
    invoiceValue: 2145.75,
    invoiceTotal: 2145.75,
    status: 'Approved',
    invoiceItems: [
      {
        id: 701,
        invoiceId: 7,
        lineNumber: 1,
        itemNumber: 'SKU-MILK-001',
        itemDescription: 'Whole Milk 2L',
        quantity: 25,
        pricePerUnit: 24.50,
        goodsValue: 612.50,
        lineValue: 612.50,
        uom: 'CASE',
        status: 'Approved',
      },
      {
        id: 702,
        invoiceId: 7,
        lineNumber: 2,
        itemNumber: 'SKU-BREAD-001',
        itemDescription: 'White Bread Loaf',
        quantity: 30,
        pricePerUnit: 18.00,
        goodsValue: 540.00,
        lineValue: 540.00,
        uom: 'CASE',
        status: 'Approved',
      },
      {
        id: 703,
        invoiceId: 7,
        lineNumber: 3,
        itemNumber: 'SKU-COFFEE-001',
        itemDescription: 'Premium Coffee Beans 1kg',
        quantity: 12,
        pricePerUnit: 85.00,
        goodsValue: 1020.00,
        lineValue: 1020.00,
        uom: 'CASE',
        status: 'Approved',
      },
    ],
  },
  {
    id: 8,
    invoiceNumber: 'INV-2026-008',
    orderNumber: 'GR-2026-003',
    storeNumber: '001',
    billingName: 'Ice Cold Distributors',
    invoiceDate: '2026-01-05',
    invoiceValue: 854.50,
    invoiceTotal: 854.50,
    status: 'Pending',
    invoiceItems: [
      {
        id: 801,
        invoiceId: 8,
        lineNumber: 1,
        itemNumber: 'SKU-ICECREAM-001',
        itemDescription: 'Vanilla Ice Cream 1L',
        quantity: 8,
        pricePerUnit: 42.00,
        goodsValue: 336.00,
        lineValue: 336.00,
        uom: 'CASE',
        status: 'Pending',
      },
      {
        id: 802,
        invoiceId: 8,
        lineNumber: 2,
        itemNumber: 'SKU-FRIES-001',
        itemDescription: 'French Fries 1kg',
        quantity: 25,
        pricePerUnit: 20.74,
        goodsValue: 518.50,
        lineValue: 518.50,
        uom: 'CASE',
        status: 'Pending',
      },
    ],
  },
];

/* ---- Mocked Client Implementation ---- */

import { IInvoiceClient } from '../../interfaces';
export class InvoiceClientMocked implements IInvoiceClient {
  constructor(baseUrl?: string) {}

  async import2(body?: CreateInvoiceRequest[], cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async reconcile(cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async invoiceGET(
    storeNumber?: string,
    invoiceNumber?: string,
    orderNumber?: string,
    ewsOrderNumber?: string,
    from?: string,
    to?: string,
    status?: string,
    sort?: string,
    direction?: string,
    skip?: number,
    take?: number,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfGetInvoicesResponse> {
    await delay();
    let filtered = [...mockInvoices];
    
    // Apply store filter with fallback for mocked environment
    if (storeNumber) {
      const storeFiltered = filtered.filter((i) => i.storeNumber === storeNumber);
      // In mocked environment, if store filter returns nothing, show all data for testing
      filtered = storeFiltered.length > 0 ? storeFiltered : filtered;
    }
    
    if (invoiceNumber) filtered = filtered.filter((i) => i.invoiceNumber.includes(invoiceNumber));
    if (orderNumber) filtered = filtered.filter((i) => i.orderNumber?.includes(orderNumber));
    if (status) filtered = filtered.filter((i) => i.status === status);

    // Date range filters
    if (from) {
      const fromDate = new Date(from);
      filtered = filtered.filter((i) => new Date(i.invoiceDate) >= fromDate);
    }
    if (to) {
      const toDate = new Date(to);
      filtered = filtered.filter((i) => new Date(i.invoiceDate) <= toDate);
    }

    // Sorting
    if (sort && direction) {
      filtered.sort((a: any, b: any) => {
        const aVal = a[sort];
        const bVal = b[sort];
        if (aVal === bVal) return 0;
        const comparison = aVal > bVal ? 1 : -1;
        return direction === 'desc' ? -comparison : comparison;
      });
    }

    const start = skip || 0;
    const end = start + (take || 10);
    return successResponse({
      invoices: filtered.slice(start, end),
      invoiceCount: filtered.length,
    }) as SuccessResponse_1OfGetInvoicesResponse;
  }

  async invoiceGET2(invoiceId: number, status?: string, sort?: string, direction?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfInvoice> {
    await delay();
    const invoice = mockInvoices.find((i) => i.id === invoiceId) || mockInvoices[0];
    return successResponse(invoice) as SuccessResponse_1OfInvoice;
  }

  async invoicePOST(invoiceId: number, body?: UpdateInvoiceRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const invoice = mockInvoices.find((i) => i.id === invoiceId);
    if (invoice && body) {
      // Note: UpdateInvoiceRequest has 'accepted' and 'note' properties
    }
  }

  async invoicePOST2(invoiceId: number, invoiceItemId: number, body?: UpdateInvoiceRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async getinvoicestatusrag(cancelToken?: CancelToken): Promise<SuccessResponse_1OfRAG> {
    await delay();
    return successResponse({
      red: 2,
      amber: 5,
      green: 149,
    }) as SuccessResponse_1OfRAG;
  }

  async getinvoicedatabyragstatus(status: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfIEnumerable_1OfInvoiceRag> {
    await delay();
    return successResponse([
      { invoiceId: 1, invoiceNumber: 'INV-001', status: status },
      { invoiceId: 2, invoiceNumber: 'INV-002', status: status },
    ]) as SuccessResponse_1OfIEnumerable_1OfInvoiceRag;
  }

  async export(invoiceId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  // ====== Auto-generated stub methods ======














}
